import { useState } from "react"

import { useDispatch, useSelector } from "react-redux"
import { notificationActions } from "../../../../../store/notifications"
import { caseActions } from "../../../../../store/case"
import CustomSelect from "../../../../common/interactive/CustomSelect"
import { isManagingAttorney } from "../../../../../lib/primaryItemScripts"

import { practicesOptions, procoDocsDocumentTypesOptions } from "../../../../../lib/systemData"
import Button from "../../../../common/Button"
import { updateDocumentApi, uploadProcodocsDocumentApi } from "../../../../../lib/fetchApi"
import { returnOnlyPracticesThatAreOnTheCase } from "../../../../../lib/misc"
import { validateBoxUploadFile } from "../../../../../lib/docs"

export default function DocumentEditable({data, isEditing, cancelEditFile, file, removeFile, caseAttorneyId, selectedPractice}) {

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false)
    const [selectedDocumentTypeId, setSelectedDocumentTypeId] = useState(isEditing  ? isEditing.procodocs_document_type_id : null)
    const [selectedPractices, setSelectedPractices] = useState(isEditing  ? isEditing.practices : null)
    const [typeBySelect, setTypeBySelect] = useState(null)
    const [practicesFilteredOptions, setPracticesFilteredOptions] = useState([])

    const [selectedPracticeId, setSelectedPracticeId] = useState([])

    const [itemLockState, setItemLockState] = useState(isManagingAttorney(activeCase)?.patient_represented == 1 ? false : true)

    let types = procoDocsDocumentTypesOptions(true)
    let practices = practicesOptions()

    // When editing an existing document, set initial type-dependent UI state.
    // (Otherwise practice select won't show until the user changes the doc type.)
    useState(() => {
        if (!isEditing) return
        const foundType = (types ?? []).find((t) => t.value == selectedDocumentTypeId)
        const initialType = foundType?.type ?? foundType?.item?.type ?? foundType?.data?.type
        if (initialType) {
            setTypeBySelect(initialType)
        }
        if (activeCase && activeCase.practices && activeCase.practices.length > 0) {
            const items = returnOnlyPracticesThatAreOnTheCase(activeCase, practices)
            setPracticesFilteredOptions(items)
        }
    })

    const saveFileHandler = async () => {
        setIsLoading(true)
        
        try {
            if (file) {
                const sizeError = validateBoxUploadFile(file.file_to_upload)
                if (sizeError) {
                    dispatch(notificationActions.setError({
                        errorMessage: `"${file.file}" is too large. ${sizeError}`,
                    }))
                    return
                }

                let formData = new FormData();

                formData.append("file", file.file_to_upload);
                formData.append("procodocs_document_type_id", selectedDocumentTypeId)
                formData.append("practices", selectedPracticeId)

                if (isManagingAttorney(activeCase)?.patient_represented == 1) {
                    formData.append("is_ecm_locked", 0)
                }

                if (!itemLockState) {
                    formData.append("is_ecm_locked", 0)
                }
            
                formData.append("case_attorney_id", caseAttorneyId)
                formData.append("for_case_attorney", 1)

                let reqBody = formData     

                const upload = await uploadProcodocsDocumentApi(userToken, activeCase.case.id, reqBody)


                if (upload?.errorMessage) {
                    dispatch(notificationActions.setError(upload))                
                } else {
                    // /success 

                    removeFile(data.id)                
                
                    // add item to store dispatch
                    dispatch(caseActions.pushItemToProcoDocuments(upload))
                }
            }
        } finally {
            setIsLoading(false)
        }
    }

    const documentTypeHandler = (value) => {
        setSelectedDocumentTypeId(value.data.value)
        const nextType = value.option?.type ?? value.option?.data?.type ?? value.option?.item?.type
        setTypeBySelect(nextType)

        if (value.data.value == 1 && practicesFilteredOptions) {
            setPracticesFilteredOptions([...practicesFilteredOptions, {
                label: 'All',
                value: 'all'
            }])
        } else {
            if (activeCase && activeCase.practices && activeCase.practices.length > 0) {
                let items = returnOnlyPracticesThatAreOnTheCase(activeCase, practices)
                setPracticesFilteredOptions(items)
            }
        }
    }

    const changePracticesHandler = (value) => {
        setSelectedPracticeId(value.data.value)
        if (selectedPractice) {
            selectedPractice(value.data.value)
        }
    }

    async function editFileHandler() {
        setIsLoading(true)
        try {
            let response = await updateDocumentApi(userToken, activeCase.case.id, data.id, {
                type: 'procodocs',
                document_type_id: selectedDocumentTypeId,
                practices: typeBySelect !== 'Practice' ? null : selectedPractices.join(','),
            })

            if (response?.errorMessage) {
                dispatch(notificationActions.setError(response))
            } else {
                dispatch(caseActions.replaceItemInProcoDocuments(response))
                cancelEditFileHandler()
            }
        } finally {
            setIsLoading(false) 
        }
    }

    const cancelEditFileHandler = () => {
        if (cancelEditFile) {
            cancelEditFile()
        }
    }

    return <>
        {/* document type  */}
        <td>
            <CustomSelect optionsData={types} action={documentTypeHandler} preSelectedValue={selectedDocumentTypeId} thin_select={true}/>
        </td>
            
        {/* practice --- this is available only if the type is practice  */}
        <td>   
            {typeBySelect == 'Practice' && practicesFilteredOptions && <CustomSelect optionsData={practicesFilteredOptions} preSelectedValue={selectedPracticeId} action={changePracticesHandler}  thin_select={true}/>}
            {typeBySelect !== 'Practice' && <>-</>} 
        </td>

        {/* is viewed  */}
        <td></td>
        {/* verify, no verify on uploading */}
        <td></td>

        {/* save document  */}
        <td>
            {!isEditing && <Button btnStyle={'btn_small'} color={'white'} click={saveFileHandler} isLoading={isLoading} isDisabled={!selectedDocumentTypeId}><i className='ti ti-check'></i>Save</Button>}
            {isEditing && <div className="flex-container">
                <Button btnStyle={'btn_small'} color={'white'} click={editFileHandler} isLoading={isLoading} isDisabled={selectedDocumentTypeId == null}><i className='ti ti-device-floppy'></i></Button>
                <Button btnStyle={'btn_simple'} color={'danger'} click={cancelEditFileHandler} ><i className='ti ti-x'></i></Button>
            </div>}
            
        </td>
    </>
}